import { render } from "./BillingClosed.vue?vue&type=template&id=5fa50ac2"
import script from "./BillingClosed.vue?vue&type=script&lang=js"
export * from "./BillingClosed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__